
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "19",
    "height": "18",
    "viewBox": "0 0 19 18"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFF",
                        "d": "M11 11.904c.443 0 4.14-4.591 4.14-6.877 0-2.287-1.854-4.14-4.14-4.14-2.286 0-4.14 1.853-4.14 4.14 0 2.286 3.713 6.877 4.14 6.877zM8.326 4.882c0-1.477 1.197-2.674 2.674-2.674 1.477 0 2.674 1.197 2.674 2.674 0 1.476-1.197 2.673-2.674 2.673-1.477 0-2.674-1.197-2.674-2.673zM18.352 8.74c0-.38-.31-.691-.692-.691h-2.52c-.053 0-.114-.003-.18.109l-.247.41c-.058.096.03.129.066.129h2.881c.023 0 .044.02.044.043l.648 5.681c0 .024-.02.044-.043.044H3.69c-.023 0-.043-.02-.043-.044l.648-5.68c0-.024.02-.044.044-.044h2.859c.058 0 .152-.034.046-.207-.125-.202-.077-.143-.208-.367-.05-.083-.117-.074-.21-.074H4.34c-.381 0-.692.31-.692.691L3 14.422c0 .38.31.69.691.69H18.31c.381 0 .691-.31.691-.69l-.648-5.682z",
                        "transform": "translate(-759 -737) translate(642 724) translate(117 13)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  